module.exports = __webpack_public_path__ + "static/media/MKR-101-badge.4426ea7d.svg";